import * as React from 'react';
import { classNames } from '@features/utils/reactFunctions';
import * as elements from '@appStyles/_elements.module.scss';

import * as style from '../../CelsiusClaimPageStyles.module.scss'

type Props = {
  handleImportFunds: () => void;
};

export const AcceptedState = ({ handleImportFunds }: Props) => {
  return (
    <>
      <h1 className={style.headerTitle}>Your request has been approved</h1>
      <p className={style.headerText}>
        Your submission has been successfully reviewed. You can now start using your imported Claim on our platform
      </p>
      <button
        className={classNames(elements.btn, style.actionButton, style.marginBottom0)}
        onClick={handleImportFunds}
      >
        View my Celsius claim
      </button>
      <div className={style.paddingBottom20} />
    </>
  );
};
